__turbopack_context__.v({
  "accessLink": "institutional-landing-module__mo_wSa__accessLink",
  "adoptionSteps": "institutional-landing-module__mo_wSa__adoptionSteps",
  "boardDiagram": "institutional-landing-module__mo_wSa__boardDiagram",
  "boardFooter": "institutional-landing-module__mo_wSa__boardFooter",
  "boardHeader": "institutional-landing-module__mo_wSa__boardHeader",
  "boardIcon": "institutional-landing-module__mo_wSa__boardIcon",
  "chatIcon": "institutional-landing-module__mo_wSa__chatIcon",
  "checkList": "institutional-landing-module__mo_wSa__checkList",
  "classroomCanvas": "institutional-landing-module__mo_wSa__classroomCanvas",
  "classroomPreview": "institutional-landing-module__mo_wSa__classroomPreview",
  "classroomTools": "institutional-landing-module__mo_wSa__classroomTools",
  "collegeMark": "institutional-landing-module__mo_wSa__collegeMark",
  "comparison": "institutional-landing-module__mo_wSa__comparison",
  "comparisonControls": "institutional-landing-module__mo_wSa__comparisonControls",
  "comparisonImage": "institutional-landing-module__mo_wSa__comparisonImage",
  "container": "institutional-landing-module__mo_wSa__container",
  "demoSection": "institutional-landing-module__mo_wSa__demoSection",
  "expandedImage": "institutional-landing-module__mo_wSa__expandedImage",
  "eyebrow": "institutional-landing-module__mo_wSa__eyebrow",
  "eyebrowDot": "institutional-landing-module__mo_wSa__eyebrowDot",
  "faq": "institutional-landing-module__mo_wSa__faq",
  "faqSection": "institutional-landing-module__mo_wSa__faqSection",
  "featureCopy": "institutional-landing-module__mo_wSa__featureCopy",
  "header": "institutional-landing-module__mo_wSa__header",
  "headerActions": "institutional-landing-module__mo_wSa__headerActions",
  "headerCta": "institutional-landing-module__mo_wSa__headerCta",
  "headerInner": "institutional-landing-module__mo_wSa__headerInner",
  "hero": "institutional-landing-module__mo_wSa__hero",
  "heroActions": "institutional-landing-module__mo_wSa__heroActions",
  "heroBenefits": "institutional-landing-module__mo_wSa__heroBenefits",
  "heroCaption": "institutional-landing-module__mo_wSa__heroCaption",
  "heroCopy": "institutional-landing-module__mo_wSa__heroCopy",
  "heroDescription": "institutional-landing-module__mo_wSa__heroDescription",
  "heroProduct": "institutional-landing-module__mo_wSa__heroProduct",
  "identityPreview": "institutional-landing-module__mo_wSa__identityPreview",
  "identitySection": "institutional-landing-module__mo_wSa__identitySection",
  "identityTokens": "institutional-landing-module__mo_wSa__identityTokens",
  "imageModal": "institutional-landing-module__mo_wSa__imageModal",
  "imageModalContainer": "institutional-landing-module__mo_wSa__imageModalContainer",
  "institutionAccess": "institutional-landing-module__mo_wSa__institutionAccess",
  "learningFeatures": "institutional-landing-module__mo_wSa__learningFeatures",
  "learningSection": "institutional-landing-module__mo_wSa__learningSection",
  "lessonBoard": "institutional-landing-module__mo_wSa__lessonBoard",
  "liveLabel": "institutional-landing-module__mo_wSa__liveLabel",
  "materialSection": "institutional-landing-module__mo_wSa__materialSection",
  "navigation": "institutional-landing-module__mo_wSa__navigation",
  "page": "institutional-landing-module__mo_wSa__page",
  "participants": "institutional-landing-module__mo_wSa__participants",
  "portalAvatar": "institutional-landing-module__mo_wSa__portalAvatar",
  "portalBody": "institutional-landing-module__mo_wSa__portalBody",
  "portalBrand": "institutional-landing-module__mo_wSa__portalBrand",
  "portalCards": "institutional-landing-module__mo_wSa__portalCards",
  "portalChrome": "institutional-landing-module__mo_wSa__portalChrome",
  "portalCourseIcon": "institutional-landing-module__mo_wSa__portalCourseIcon",
  "portalHeader": "institutional-landing-module__mo_wSa__portalHeader",
  "previewBar": "institutional-landing-module__mo_wSa__previewBar",
  "primaryButton": "institutional-landing-module__mo_wSa__primaryButton",
  "proofHeading": "institutional-landing-module__mo_wSa__proofHeading",
  "proofLayout": "institutional-landing-module__mo_wSa__proofLayout",
  "proofSection": "institutional-landing-module__mo_wSa__proofSection",
  "proofSource": "institutional-landing-module__mo_wSa__proofSource",
  "proofStat": "institutional-landing-module__mo_wSa__proofStat",
  "proofStats": "institutional-landing-module__mo_wSa__proofStats",
  "role": "institutional-landing-module__mo_wSa__role",
  "roleBody": "institutional-landing-module__mo_wSa__roleBody",
  "roleGrid": "institutional-landing-module__mo_wSa__roleGrid",
  "roleIcon": "institutional-landing-module__mo_wSa__roleIcon",
  "roleLabel": "institutional-landing-module__mo_wSa__roleLabel",
  "roleNumber": "institutional-landing-module__mo_wSa__roleNumber",
  "roleTop": "institutional-landing-module__mo_wSa__roleTop",
  "section": "institutional-landing-module__mo_wSa__section",
  "sectionHeader": "institutional-landing-module__mo_wSa__sectionHeader",
  "sectionIntro": "institutional-landing-module__mo_wSa__sectionIntro",
  "splitSection": "institutional-landing-module__mo_wSa__splitSection",
  "studentTiles": "institutional-landing-module__mo_wSa__studentTiles",
  "studyChat": "institutional-landing-module__mo_wSa__studyChat",
  "swatches": "institutional-landing-module__mo_wSa__swatches",
  "teacherTile": "institutional-landing-module__mo_wSa__teacherTile",
  "textButton": "institutional-landing-module__mo_wSa__textButton",
  "zoomIcon": "institutional-landing-module__mo_wSa__zoomIcon",
});
